export default __webpack_public_path__ + "static/media/trash-icon.f80c553b.svg";